const BadgeController = require('./badge-controller');


module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'ctrl',
        controller: BadgeController,
        bindToController: {
            savingsAmount: '=',
            size: '@?'
        },
        scope: {},
        template: require('./savings-badge-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/badges/savings-badge-directive.js
 **/